export const monthCalendar = [
    {
        id: 1,
        name: "Enero",
        reference: "Jan",
        numberMount: '01'
    },
    {
        id: 2,
        name: "Febrero",
        reference: "Feb",
        numberMount: '02'
    },
    {
        id: 3,
        name: "Marzo",
        reference: "Mar",
        numberMount: '03'
    },
    {
        id: 4,
        name: "Abril",
        reference: "Apr",
        numberMount: '04'
    },
    {
        id: 5,
        name: "Mayo",
        reference: "May",
        numberMount: '05'
    },
    {
        id: 6,
        name: "Junio",
        reference: "Jun",
        numberMount: '06'
    },
    {
        id: 7,
        name: "Julio",
        reference: "Jul",
        numberMount: '07'
    },
    {
        id: 8,
        name: "Agosto",
        reference: "Aug",
        numberMount: '08'
    },
    {
        id: 9,
        name: "Septiembre",
        reference: "Sep",
        numberMount: '09'
    },
    {
        id: 10,
        name: "Octubre",
        reference: "Oct",
        numberMount: '10'
    },
    {
        id: 11,
        name: "Noviembre",
        reference: "Nov",
        numberMount: '11'
    },
    {
        id: 12,
        name: "Diciembre",
        reference: "Dec",
        numberMount: '12'
    }
]